export const getError = (error: unknown): { name: string; message: string } => {
  if (error instanceof Error) {
    return error;
  } else if (typeof error === 'string') {
    return {
      name: 'Unknown error',
      message: error,
    };
  }
  return {
    name: 'Unknown error',
    message: 'Unknown error',
  };
};
